import * as React from 'react';

interface Props {
  color: string
}

const BubbleLoader: React.FC<Props> = (props) => {
  return (
    <div className="flex py-2 px-2">
      <div
        className="animate-expand  w-2 h-2 mx-1 rounded-full"
        style={{ backgroundColor: props.color }} />
      <div
        className="animate-expand  w-2 h-2 mx-1 rounded-full"
        style={{ backgroundColor: props.color, animationDelay: '180ms' }}
      />
      <div
        className="animate-expand  w-2 h-2 mx-1 rounded-full"
        style={{ backgroundColor: props.color, animationDelay: '360ms' }}
      />
    </div>
  )
}


export default BubbleLoader;